import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { checkUserHasAccess } from "./Common";

function RoleRestrictedRoute({ allowedRoles, element, redirectTo = "/" }) {
  const { userLevelId } = useAuth();

  if (checkUserHasAccess(allowedRoles, userLevelId)) {
    return element;
  }

  return <Navigate to={redirectTo} replace />;
}

export default RoleRestrictedRoute;
